import { Capacitor } from '@capacitor/core';
import { isNativeMonthly699SourceProductId } from '@/services/nativeBilling';

/**
 * Whether a store subscription status can see the in-app cancel offer
 * ("Cancel Premium"). Paying members always can. iOS members in a free trial
 * can too (Alex, Oct 22 2026): Apple starts a promotional offer bought during
 * an introductory offer at the next billing event, so the trial runs out
 * first. Android members in a free trial can only on the $12 monthly plan
 * (Oct 23 2026): Play's next-billing-date switch keeps the trial and starts
 * the monthly offer when it ends. Pass the product to allow that case; the
 * annual switch never passes it, so Android trials never get the annual.
 */
export function isNativeCancelOfferStatus(
  status: string | null | undefined,
  productIdentifier?: string | null,
): boolean {
  if (status === 'active') return true;
  if (status !== 'trialing') return false;
  if (!productIdentifier && Capacitor.getPlatform() !== 'ios') return false;
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') return true;
  return platform === 'android' && isNativeMonthly699SourceProductId(productIdentifier);
}
